module.exports = angular.module("pascalprecht.translate");


//////////////////
// WEBPACK FOOTER
// external "angular.module(\"pascalprecht.translate\")"
// module id = 384
// module chunks = 0